interface BrandLogoProps {
  size?: number;
  className?: string;
}

// Two overlapping rounded rectangles — two cards being synced.
// Back card: outline in light blue. Front card: filled mid-blue, white stroke,
// offset down-right.
export function BrandLogo({ size = 40, className }: BrandLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="CARD SYNC logo"
      className={className}
    >
      <rect width="40" height="40" rx="12" fill="#2563EB" />
      <rect
        x="8"
        y="10"
        width="20"
        height="14"
        rx="2.5"
        fill="none"
        stroke="#93C5FD"
        strokeWidth="1.5"
      />
      <rect
        x="12"
        y="16"
        width="20"
        height="14"
        rx="2.5"
        fill="#60A5FA"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  );
}
